export function isValidDate (date: Date): boolean {
  return date instanceof Date && !isNaN(date.getTime())
}

export function getUTCDate (
  date: Date = new Date(),
  hours = 0,
  minutes = 0,
  seconds = 0
): Date {
  const year = date.getUTCFullYear()
  const month = date.getUTCMonth()
  const day = date.getUTCDate()

  return new Date(year, month, day, hours, minutes, seconds)
}

export function datesAreEqual (date1: Date, date2: Date): boolean {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}

export function dateIsInThePast (dateToTest: Date, today = new Date()): boolean {
  const todayInUTC = getUTCDate(today)
  const dateToTestInUTC = getUTCDate(dateToTest)

  return dateToTestInUTC < todayInUTC
}

export function formatAsYearMonthDay (date: Date): string {
  // Use local date components to create the YYYY-MM-DD string
  const year = date.getFullYear();
  // Month is 0-indexed in JavaScript, so add 1 and pad with leading zero if needed
  const month = String(date.getMonth() + 1).padStart(2, '0');
  // Day of month, padded with leading zero if needed
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
